// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"e527a1e9","213":"d460e2da","239":"07641345","397":"e21be246","455":"f3bb6c88","459":"8933c4ee"}[chunkId] + ".chunk.js";
};